<template>
    <div>
        <b-datatable
            ref="grid"
            :key="datatableKey"
            :columns="columns"
            :endpoint="listRoute"
            :hidden-columns="hiddenColumns"
            :initial-filters="initialFilters"
            :initial-sort="initialSort"
            item-key="id"
            :grid-title="gridTitle"
            keep-filters-prefix="missing"
        >
            <template #filters="{ filters }">
                <v-col cols="3" class="pb-0">
                    <b-filter-date
                        v-model="filters.filters.filter_date_taken"
                        range
                        :label="t('spire-ftp::filters.label.sample_date')"
                        @clear="onCloseDateFilter(filters, 'filter_date_taken')"
                    ></b-filter-date>
                </v-col>
            </template>

            <template #[`item.date_taken`]="{ item }">
                {{ item.date_taken ? moment(item.date_taken).format($root.dateFormat) : t('default::label.na') }}
            </template>

            <template #[`item.created_at`]="{ item }">
                {{ item.created_at ? moment(item.created_at).format($root.dateFormat) : t('default::label.na') }}
            </template>

            <template #[`item.patient`]="{ item }">
                <div v-if="can('patients.get')" class="link" @click="$root.goTo(patientItemUrl(item.patient))">
                    {{ item.patient.dms_id }}
                </div>
                <div v-else>
                    {{ item.patient.dms_id }}
                </div>
            </template>

            <template #[`item.file_name`]="{ item }">
                <div class="grid-status">
                    <span v-text="item.file_name"></span>
                </div>
            </template>

            <template #[`item.actions`]="{ item }">
                <div class="table-actions">
                    <v-tooltip v-if="can('spire-blood-results.export-record-as-pdf')" top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn
                                color="disabled-color"
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="exportRecordAsPdf(item)"
                            >
                                <v-icon size="24">mdi-file-export-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('default::button.export_record_as_pdf') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="can('api.v1.spire-blood-results.index')" top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn color="disabled-color" icon v-bind="attrs" v-on="on" @click="viewFile(item)">
                                <v-icon>mdi-text-box-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('spire-ftp::button.view_file') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.patient && item.blood_result_id" top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn color="disabled-color" icon v-bind="attrs" v-on="on" @click="viewSample(item)">
                                <v-icon>mdi-clipboard-account-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('spire-ftp::button.view_sample') }}</span>
                    </v-tooltip>

                    <b-delete
                        v-if="!item.blood_result_id && can('api.v1.spire-blood-results.destroy')"
                        :path="deleteItemUrl(item)"
                        :text="t('default::confirmation.deletion')"
                        :title="t('default::confirmation.general')"
                        icon="mdi-trash-can"
                        @deleted="triggerDeleted"
                    >
                    </b-delete>
                </div>
            </template>
        </b-datatable>
        <spire-ftp-preview-modal v-model="previewModal"></spire-ftp-preview-modal>
    </div>
</template>

<script>
const SpireDataTableMixin = require('../../mixins/SpireDataTableMixin.js').default;
export default {
    mixins: [SpireDataTableMixin],
    data() {
        return {
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('spire-ftp::grid.label.arrived_at'),
                    value: 'created_at',
                    sortable: true,
                    width: 200,
                },
                {
                    text: t('spire-ftp::grid.label.sample_date'),
                    value: 'date_taken',
                    sortable: true,
                    width: 200,
                },
                {
                    text: t('spire-ftp::grid.label.file_name'),
                    value: 'file_name',
                    width: 200,
                    sortable: true,
                },
                {
                    text: t('default::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: 'blood_result_id',
                    width: 200,
                    align: 'end',
                },
            ],
        };
    },
    computed: {
        datatableKey: {
            get() {
                return this.$store.state.spire.datatableKeyMissing;
            },
            set(value) {
                return this.$store.dispatch('spire/incremetDateTableKeyMissing', value);
            },
        },
    },
};
</script>
